<template>
    <div class="page">
        <box fill>





          <div style="overflow: hidden; padding-bottom: 10px">
            <el-form label-position="right" label-width="80px" :model="printObjs">
              <el-col :lg="5" :xl="5">
                <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.soCode"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.matCode"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="批次号" prop="batchNo" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.batchNo"> </el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item class="btn-edit-delete EL-Form-Item">
                  <el-button type="primary" class="btn-t-edit" @click="getOutsourcePrintList()">查询</el-button>
                  <el-button type="primary" class="btn-t-edit"  @click="submitOutsource()">确认提交</el-button>
                  <el-button type="primary" class="btn-t-edit"  @click="downLoadFile()">导出EXCEL</el-button>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="进行中" prop="batchNo" class="EL-Form-Item">
                  <el-select v-model="printObjs.soStatus">
                    <el-option label="全部" value="30,40,80,90"></el-option>
                    <el-option label="进行中" value="30,80,90"></el-option>
                    <el-option label="完成" value="40"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="物料描述" prop="matName" class="EL-Form-Item">
                  <el-input v-model.trim="printObjs.matName"> </el-input>
                </el-form-item>
              </el-col>

              <!--
              <el-button type="primary" class="btn-t-edit" style="margin-top:10px;margin-bottom:10px;float: right;" @click="pdfPrint()">打印</el-button>
-->
            </el-form>
          </div>
          <h-table  :summaryMethod="getSummaries" show-summary  :headerCellStyle="headerCellStyle" style="flex: 1"  :data="outsourcePrintList" @selectionChange="selectOutsourcePrint" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total" @pageChange="getOutsourcePrintList" >
            <el-table-column type="selection" align="center">
            </el-table-column>
            <el-table-column label="外协单号" prop="soCode" align="center">
            </el-table-column>
            <el-table-column label="物料编号" prop="matCode" align="center">
            </el-table-column>
            <el-table-column label="物料描述" prop="matName" align="center">
            </el-table-column>
            <el-table-column label="通道" prop="whCode" align="center">
            </el-table-column>
            <el-table-column label="批次" prop="batchNo" palign="center">
            </el-table-column>
            <el-table-column label="总数" prop="boxQuan" align="center">
            </el-table-column>
            <el-table-column label="库存数量" prop="matQuan" align="center">
            </el-table-column>
            <el-table-column label="调整数量" prop="adjustQuan" align="center">
            </el-table-column>
            <el-table-column label="已发数量" prop="sumQuan" palign="center">
            </el-table-column>

            <el-table-column label="每箱数量" prop="printCount" palign="center">
              <template slot-scope="scope" >
                <el-input-number v-model="scope.row.printCount" style="width: 100px;line-height: 26px !important" :min="0" size="mini"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="箱数" prop="splitBoxCount" palign="center">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.splitBoxCount" style="width: 100px;line-height: 26px !important" :min="0" :max="20" size="mini"></el-input-number>
              </template>
            </el-table-column>

          </h-table>







        </box>
    </div>
</template>

<script>
    import moment from "moment";
    import OutsourceLabelReturn from "@/views/printPages/outsource-label-return.vue";
    import vPrint from 'syl-vue-printer'
    export default {
        name: "supplierOutsource",
        components: {
          OutsourceLabelReturn,
          vPrint

        },
        data() {
            return {
                printData: [], //打印数据
                print: false,
                printShow: false,
                prints: false,
                printShows: false,
                printObj: {
                    id: "demo",
                    popTitle: "",
                },
                user:localStorage.getItem("user"),
                summarySumNumber:0,
                boxNumber:"",
                soCode:"",
                printTime: moment(new Date).format("yyyy-MM-DD"),
                editNumShow:false,
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                whCodes:"",
                oldMatQuan:"",
                form: {},
              // 标签打印
                labelPrintShow: false,
                labelPrintFlag: false,
                labelPrintData: null,
                //主数据
                mainData: [],
                pagination: {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                },
              mainNum:{
                nowNum:"",
              },
				searchInfo: {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30,80,90",
                    whCode: localStorage.getItem("whCode") || "",
                    //laCode: "",
                    laCode: localStorage.getItem("empNumber") || "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
				},
                printObjs:{
                    matCode:"",
                    batchNo:"",
                    soCode:"",
                    soStatus:"30,80,90",
                    matName:"",
                },

                warehouseList: [],
                mainObj: {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                },
                rules: {
                    soCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    laOutsouceCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    boxBarcode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },

                addOutsourceList: [],

                laCodeList: [],
                checkOutsourceList: [], //多选

                editBoxShow: false,

                downloadLoading: false, //下载中

                detailsDialogShow: false,
                detailsDialogShows:false,
                outsourceLists: [],
                checkListDet: [], //全选

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
                //打印显示
                outsourcePrintList:[],
                checkoutsourcePrintList: [], //多选
            };
        },
        watch: {
            searchInfo: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getOutsource(newVal);
                    }, 1000)
                },
                deep: true,
            },
        },
        computed: {
            pickerOptions() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[0]) {
                            return time.getTime() < new Date(_this.searchInfo.requireDate[0]);
                        }
                    }
                }
            },
            pickerOptions0() {
                let _this = this
                return {
                    disabledDate(time) {
                        if (_this.searchInfo.requireDate[1]) {
                            return time.getTime() > new Date(_this.searchInfo.requireDate[1]);
                        }
                    }
                }
            },
        },
        methods: {
          //表单验证
          submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
              if (valid) {
                r = true;
              } else {
                r = false;
              }
            });
            return r;
          },

            //打印多选
            selectOutsourcePrint(val) {
                this.checkListDet = val;
            },


          /**
           *提交并且打印标签
           */
          submitOutsource() {

            if(this.checkListDet.length == 0){

              this.$message.warning({
                title: "提示",
                message: "请选择待打印记录",
              });

              return false;
            }
            if(this.checkListDet.length > 1){

              this.$message.warning({
                title: "提示",
                message: "只能选择一条打印",
              });

              return false;
            }

            for(var idx in this.outsourceLists){
              this.outsourceLists[idx].nowPrintCount = 0;
            }

            for(var index in this.checkListDet){
              if(this.checkListDet[index].printCount == "" || this.checkListDet[index].printCount == undefined){
                this.$message.warning({
                  title: "提示",
                  message: "选中打印记录中的数量不能为空！",
                });
                return;
              }
              if(this.checkListDet[index].splitBoxCount == "" || this.checkListDet[index].splitBoxCount == undefined){
                this.$message.warning({
                  title: "提示",
                  message: "选中打印记录中的箱数不能为空！",
                });
                return;
              }
              if(this.checkListDet[index].splitBoxCount>1){
                // this.$message.warning({
                //   title: "提示",
                //   message: "一次只能打印一张",
                // });
                //
                // return false;
              }

              if((this.checkListDet[index].boxQuan - this.checkListDet[index].completeCount) < (this.checkListDet[index].printCount * this.checkListDet[index].splitBoxCount)){
                this.$message.warning({
                  title: "提示",
                  message: "打印数量超过当前总数量",
                });
                return;
              }


              for(var idx in this.outsourceLists){

                if(this.outsourceLists[idx].soStatus == '30' && this.outsourceLists[idx].batchNo == this.checkListDet[index].batchNo){

                  this.outsourceLists[idx].nowPrintCount += (this.checkListDet[index].printCount * this.checkListDet[index].splitBoxCount);

                }

              }
            }

            //计算当前可打印数量

            for(var idx in this.outsourceLists){
              if(this.outsourceLists[idx].soStatus == '30' && (this.outsourceLists[idx].boxQuan - this.outsourceLists[idx].boxCheckQuan)
                  < this.outsourceLists[idx].nowPrintCount){

                this.$message.warning({
                  title: "提示",
                  message: this.outsourceLists[idx].batchNo + "打印数量超过当前外协总数量",
                });
                return;

              }
            }

            this.checkListDet[0].person = localStorage.getItem("user");
            this.checkListDet[0].personNumber = localStorage.getItem("empNumber");

            // return;

            this.$confirm("提交并且打印标签? ", "提示", {
              confirmButtonText: "确认",
              cancelButtonText: "取消",
              type: "warning",
            })
                .then(() => {
                  this.$http
                      .request({
                        url: "/api/outsource/insertOutsourcePrint",
                        method: "POST",
                        showLoading: true,
                        data: this.checkListDet
                      })
                      .then((res) => {
                        if (res.status == 100) {
                          this.$message({
                            title: "成功",
                            message: "操作成功！",
                            type: "success",
                          });
                          this.logRemarks = "outsource：外协标签打印";
                          this.getOutsourcePrintList();

                          var returnData = res.data;

                          //标签打印
                          returnData.forEach((item) => {
                            var produceTime = moment(item.fifoDate).format("YYYYMMDD");
                            //T/采购订单/箱号/物料号/数量/规值/批次/生产日期/高度
                            // var qrCode = "T/" + item.orderCode + "/" + item.boxBarcode + "/" + item.matCode + "/" +
                            //     item.matQuan + "/" + item.matSpecs + "/" + item.batchNo +
                            //     "/" + produceTime + "/" + item.boxHeight + "/";

                            //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                            var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                                "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                            if (item.matSpecs == undefined) {
                              item.matSpecs = "";
                            }

                            var person = localStorage.getItem("user");
                            if (person != undefined && person != '') {
                              person = item.consignee;
                            }

                            var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                            var barcodeData = {
                              boxBarcode: item.boxBarcode,
                              prodCode: item.matCode,
                              prodName: item.matName,
                              batchNo: item.batchNo,
                              count: item.boxQuan,
                              checkPerson: person,
                              date: produceTime,
                              poCode: item.orderCode,
                              matSpecs: item.matSpecs,
                              produceCode:item.finishProduct,
                              whCode: item.whCode,
                              qrCode: qrCode,
                              supply: item.verdorCode,
                              printTime: printTime,
                              isSta: false,
                              printTwo: false,
                              location: item.laCheckCode,
                              boxHeight: item.boxHeight,
                              heatBatchNo: item.heatNumber,
                              luhao: item.heatNo,
                              oldBoxbarcode: this.checkListDet[0].soCode,
                              checkResult: "20",
                              orderNumber:item.opCode,
                              produceDesc:item.finishProductName,
                            }
                            this.$printer.printWMSBarcodeWx(barcodeData);





                            //this.labelPrintShow = true;
                            var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                            var printTime = moment().format("YYYY-MM-DD");
                            var qrCode = item.orderCode+","+item.matCode+","
                                +","+item.verdorCode+","+item.whCode+",,"+item.batchNo+
                                ","+item.heatNumber+","+item.matSpecs+","+item.checkType+","+item.boxQuan+
                                ","+item.palletCode+","+item.boxBarcode+",,,"+produceTime+","+item.soCode;
                            this.labelPrintData = {
                              value1: item.boxBarcode,
                              value2: qrCode,
                              soCode:item.soCode,
                              matCode:item.matCode,
                              matName:item.matName,
                              whCode:item.whCode,
                              printTime:printTime,
                              matQuan:item.boxQuan,
                              batchNo:item.batchNo,
                              palletCode:item.palletCode,
                              boxBarcode:item.boxBarcode,
                              laOutsouceCode:item.laCheckCode,
                              wxName:localStorage.getItem("user"),
                              isFg:item.checkResult='20'?'否':'是',
                              type:item.checkType,
                              matSumQuan:item.matSumQuan,

                            }

                            /*
                              var produceTime = moment().format("YYYYMMDD");


                              //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                              var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                  item.matCode + "," + item.boxQuan + "," + item.matSpecs +
                                  "," + item.batchNo + "," + produceTime + ",2,,,";

                              if (item.matSpecs == undefined) {
                                  item.matSpecs = "";
                              }

                              var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                              var barcodeData = {
                                  boxBarcode: item.boxBarcode,
                                  prodCode: item.matCode,
                                  prodName: item.matName,
                                  batchNo: item.batchNo,
                                  count: item.boxQuan,
                                  checkPerson: localStorage.getItem("empNumber"),
                                  date: produceTime,
                                  poCode: item.orderCode,
                                  matSpecs: item.matSpecs,
                                  whCode: item.whCode,
                                  qrCode: qrCode,
                                  supply: localStorage.getItem("userName"),
                                  printTime: printTime,
                                  printTwo: 2,
                                  supplyName: localStorage.getItem("userName"),
                                  // fcAddress: localStorage.getItem("fcCode")=='DLM'?'铁山东三路53号':'淮河中路87号',
            fcAddress: item.fcCode=='DLM'?'铁山东三路53号':'淮河中路87号',
                                  fcName: "斯凯孚大连轴承与精密技术有限公司"
                              }

                              // console.log(barcodeData);

                              this.$printer.printWMSSupplyBarcode(barcodeData);

                             */
                          })
                        } else {
                          this.$message.error({
                            title: "失败",
                            message: res.message,
                          });
                          this.logContent = JSON.stringify(this.checkOutsourceList);
                          this.systemLog();
                          this.logRemarks = "outsource：外协标签打印";
                        }
                        this.getOutsource();
                      });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });



          },




            //获取数据
            getOutsourcePrintList(){
                 this.$http
                    .request({
                        url: "/api/outsource/getOutsourcePrintDetailQuanList",
                        method: "GET",
                        params: {
                            soCode: this.printObjs.soCode || null,
                            matCode: this.printObjs.matCode || null,
                            batchNo: this.printObjs.batchNo || null,
                            matName: this.printObjs.matName || null,
                            laCheckCode:localStorage.getItem("user"),
                            soStatus:this.printObjs.soStatus,
                            pageNum:this.pagination.pageNum,
                            pageSize:this.pagination.pageSize,

                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                                this.outsourcePrintList = resp.data.list || []
                                this.pagination.total = resp.data.total;
                            } else {
                                this.$message({
                                    type: "warning",
                                    message: "未找到记录！",
                                });
                            }
                            this.tablesoCode = ""
                    })
            },



            //清除
            clearOutsource() {
                this.mainObj = {
                    soCode: "",
                    laOutsouceCode: "",
                    boxBarcode: ""
                }
                this.addOutsourceList = []
            },

            //重置
            resetData() {
                this.pagination = {
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
				};
				this.searchInfo = {
                    soCode: "",
                    boxBarcode: "",
                    matCode: "",
                    person: "",
                    soStatus: "30",
                    whCode: localStorage.getItem("whCode") || "",
                    laCode: "",
                    supplyNumber: localStorage.getItem("user"),
                    fcCode: localStorage.getItem("fcCode") || "",
                    requireDate: []
                };
                this.getOutsource();
            },

            //表格导出
            downLoadFile() {

                let list = [];

                this.downloadLoading = true;
                var paramsObj = {
                    soCode: this.printObjs.soCode || null,
                    matCode: this.printObjs.matCode || null,
                    batchNo: this.printObjs.batchNo || null,
                    laCheckCode:localStorage.getItem("user"),
                    soStatus:this.printObjs.soStatus,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/outsource/getOutsourcePrintDetailQuanList',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    // list.forEach(function(c) {
                    //
                    //     if (c.soStatus == '80') {
                    //         c['soStatus'] = '待接收'
                    //     } else if (c.soStatus == '40') {
                    //         c['soStatus'] = '收货完成'
                    //     } else if (c.soStatus == '90') {
                    //       c['soStatus'] = '发货完成'
                    //     } else if (c.soStatus == '30') {
                    //       c['soStatus'] = '出库完成'
                    //     } else if (c.soStatus == '50') {
                    //         c['soStatus'] = '关闭'
                    //     }else if (c.soStatus == '70') {
                    //         c['soStatus'] = '完成'
                    //     }
                    //
                    //     if (c.scanFlag == true) {
                    //         c['scanFlag'] = '是'
                    //     } else if (c.scanFlag == false) {
                    //         c['scanFlag'] = '否'
                    //     }
                    // })
                    const tHeader = [ '外协单号', '箱数物料编号', '物料描述','通道','批次','总数','库存数量','调整数量','已发数量'

                    ]
                    const filterVal = [ 'soCode', 'matCode', 'matName', 'whCode','batchNo','boxQuan','matQuan','adjustQuan','sumQuan'

                    ]
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '供应商外协详情'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "stock_outsource：供应商外协详情"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },



          getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '合计';
                return;
              }
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value)) && (column.property == "matQuan" || column.property =="boxQuan" || column.property == "adjustQuan" ||  column.property == "sumQuan")) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index];
              }
            });

            return sums;
          },
            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "供应商外协",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },








        },
        activated(){
            /* 获取首页的数据 */
          this.getOutsourcePrintList();
        },
    };
</script>

<style>
.div span {
  margin-left: 50px;
}

.table table {
  margin-top: 20px;
}

.table table tr td {
  width: 100px;
  height: 50px;
  border: 1px solid black;
  text-align: center;
}

.table table tr th {
  width: 100px;
  height: 80px;
  border: 1px solid black;
  font-weight: 800;
  font-size: 18px;
}

.td td {
  font-weight: 800;
}
</style>
